export default "__VITE_ASSET__0ba9d94a__"